import { Injectable } from '@angular/core';
import { isUndefined } from '../codeUtils';
import { EventsService } from '../event/event.service';

@Injectable({
  providedIn: 'root'
})
export class FundsIndicatorService {
  
  public showBalance: boolean = true;

  constructor(
    public eventsService: EventsService
  ) { 
    this.eventsService.subscribe("event:balanceState",  data => {
      this.updateShowBalance(data);
    });
  }

  updateShowBalance(data) {
      this.showBalance = data.show;
    
      let code = (!isUndefined(data.code)) ? data.code : "";
      if(code == 'IN_GAME') return this.showBalance = false;
  }
}
